import * as z from 'zod';
import { zPassword } from './error-messages';

export const completeSignUpFormSchema = z.object({
  password: zPassword,
});

export type CompleteSignUpFormData = z.TypeOf<typeof completeSignUpFormSchema>;
